import { liteClient as algoliasearch } from 'algoliasearch/lite'

// Algolia configuration
export const ALGOLIA_APP_ID = '6Q97VR634D'
export const ALGOLIA_SEARCH_API_KEY = 'df20c9cc488dfce7d822b120641a767d'
export const ALGOLIA_INDEX_NAME = 'assets'

// Create the Algolia search client
export const searchClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_API_KEY)
